<template>
    <div class="container">
        <div class="row">
            <div class="col-4">
                <h2 class="h h--2 h--dark">Zamówione nagrody</h2>
                <p class="paragraph">Historia zamówionych przez Ciebie nagród.</p>
            </div>
            <div class="col-8" v-bind:class="{'pending': pagination.pending}">
                <div v-if="prizes.length > 0">
                  <table class="invoices__table">
                      <tr>
                          <th>nagroda</th>
                          <th>punktów</th>
                          <th>status</th>
                          <th>data dodania</th>
                      </tr>
                      <tr v-for="item in prizes" :key="item.id">
                          <td><b>{{ item.orders.quantity > 1 ? item.orders.quantity+' x ':''}}</b>{{ item.orders.prize ? item.orders.prize.name : '' }}</td>
                          <td>{{ item.sum_values }}</td>
                          <td><span class="invoices__status" :class="'invoices__status--' + item.status.id">{{ item.status.name }}</span></td>
                          <td>{{ item.created_at }}</td>
                      </tr>
                  </table>
                  <pagination v-model="pagination.current_page" :page="pagination.current_page" :per-page="parseInt(pagination.per_page)" :records="pagination.total" @paginate="onChangePaginate" v-if="pagination && pagination.last_page > 1"></pagination>
                </div>
                <div class="profile" v-if="prizes.length == 0">
                    <p>brak zamówionych nagród</p>
                </div>
            </div>
        </div>
        <page-box-set-widget prizes="true"></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'PrizesComponent',
  data () {
    return {
      prizes: [],
      pagination: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.axios({
      method: 'get',
      url: '/users/current/ordersHistory'
    })
    .then(response => {
      next(vm => {
        vm.prizes = response.data.data.orders
        vm.pagination = response.data.pagination
      })
    })
    .catch(error => next(false))
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/zamowione-nagrody',
        })
    }
  },
  methods: {
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
      if (!this.name) {
        alert('Please enter your name')
      } else {
        this.handleSubmit()
      }
    },
    handleSubmit () {
      this.names.push(this.name)
      this.clearName()
      this.$refs.modal.hide()
    },

    /**
     * On change paginate event.
     *
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
      let vm = this

      vm.pagination.pending = true

      Vue.axios({
        method: 'get',
        url: '/users/current/ordersHistory',
        params: {
          page: page
        }
      })
      .then(response => {
        vm.prizes = response.data.data.orders
        vm.pagination = response.data.pagination
      })
      .catch(error => pagination.pending = false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/prizes/MyPrizesComponent.vue